import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container } from 'styles/layout';

export const Container = styled.div`
  ${container}

  padding-right: 6px;

  ${large`
    padding-right: 0;
  `}
`;
